'use client';

import { FC, PropsWithChildren } from 'react';
import { GithubProvider } from './_context/GithubContext';

import 'styles/legacy/application.scss';
import 'styles/legacy/font.scss';

const IntegrationsLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <GithubProvider>{children}</GithubProvider>;
};

export default IntegrationsLayout;
